import type React from 'react';

import './styles.scss';

type CardProps = { children?: React.ReactNode; className?: string };

export const Card = ({ children, className = '' }: CardProps) => (
	<div className={`card ${className}`}>{children}</div>
);
